import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/hire-ios-app-developers/end_hire_ios.webp";

const Androidbuss = () => {
  return (
    <div
      className="androidbuss tekrevol_dark_bg hire_ios_end p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              End-to-End iOS App <span>Development Competencies</span>
            </h2>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Proficiency in Swift</h6>
                <p>
                  Our developers are proficient in Swift, the modern language
                  recommended by Apple for native iOS development. Swift’s
                  advanced operators, lightweight syntax, and high readability
                  allow our team to write efficient and maintainable code. This
                  proficiency not only speeds up development but also enhances
                  App Store Optimization, ensuring your app stands out.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Expertise in Objective-C</h6>
                <p>
                  We offer developers who excel in Objective-C, the backbone of
                  many existing iOS applications and Apple's Cocoa framework.
                  Objective-C's powerful extensions and robust object-oriented
                  capabilities make it ideal for complex projects. Whether your
                  project requires Swift or Objective-C, our team ensures
                  seamless integration and high performance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Advanced Version Control</h6>
                <p>
                  Our iOS developers are experts in using version control tools
                  like Git, SVN, and Mercurial. These tools are essential for
                  managing code changes, collaborating effectively, and
                  maintaining project integrity. With our advanced version
                  control practices, we ensure smooth scaling and precise
                  control at every development stage.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Comprehensive Database Expertise</h6>
                <p>
                  Our team possesses extensive knowledge of various database
                  management systems, including MongoDB, Oracle, MySQL, and
                  SQLServer. This expertise enables us to develop robust,
                  cohesive iOS apps that can handle large datasets and scale
                  efficiently as your business grows.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Dynamic iOS Frameworks</h6>
                <p>
                  Our developers are adept at using the latest iOS frameworks
                  and libraries such as SwiftUI, Quartz Core, realm, and
                  RxSwift. Coupled with expertise in Xcode, the leading IDE for
                  Apple development, we deliver high-performance applications
                  that leverage the full capabilities of iOS technologies.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Interactive UI/UX Design</h6>
                <p>
                  Understanding the importance of a seamless user experience,
                  our developers have a strong grasp of UI/UX principles. This
                  knowledge allows them to collaborate effectively with
                  designers to create intuitive, visually appealing, and
                  user-friendly iOS applications that delight users and enhance
                  engagement.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
